module.exports = __webpack_public_path__ + "img/M0012.921a51be.png";